var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('base-loader'),_c('notification'),_c('SessionTimeoutDialog',{ref:"sessionTimeoutDialog",on:{"session-resumed":_vm.handleSessionResumed}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }